import { render, staticRenderFns } from "./KeywordCriteriaGroup.vue?vue&type=template&id=8a5da1a0&"
import script from "./KeywordCriteriaGroup.vue?vue&type=script&lang=ts&"
export * from "./KeywordCriteriaGroup.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports